module.exports = __webpack_public_path__ + "static/media/modamilyBabyLarge.49f30a55.png";